import React from 'react';
import { useTranslation } from 'react-i18next';

import defaultUserImage from 'assets/default-user.png';
import { ChallengeResultType } from 'interfaces';
// eslint-disable-next-line import/no-cycle
import PhotoRank from '../PhotoRank';
// eslint-disable-next-line import/no-cycle
import {
  StyledCircle,
  StyledContainer,
  StyledUserPhotoImage,
} from './UsersPhoto.styles';

export type PhotoSizeType = 'normal' | 'small' | 'large';
export type PhotoStatusType = 'default' | 'disabled' | 'primary' | 'secondary';

type PhotoType = {
  imageUrl?: string;
  challengeResults?: ChallengeResultType;
  withRank?: boolean;
  size?: PhotoSizeType;
  status: PhotoStatusType;
};

const UsersPhoto = ({
  imageUrl,
  challengeResults,
  withRank = false,
  size = 'normal',
  status = 'default',
}: PhotoType): JSX.Element => {
  const { t } = useTranslation();
  const isDisabled = status === 'disabled';

  return (
    <StyledContainer className={status}>
      {withRank && !isDisabled && (
        <PhotoRank
          challengeResults={challengeResults}
          size={size}
          isHighlighted={status === 'secondary'}
        />
      )}
      <StyledCircle size={size}>
        <StyledUserPhotoImage
          size={size}
          disabled={isDisabled}
          src={imageUrl || defaultUserImage}
          alt={t('challenges.my_picture')}
        />
      </StyledCircle>
    </StyledContainer>
  );
};

export default UsersPhoto;
